module.exports = __webpack_public_path__ + "img/cyjh.15a9783b.png";